/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface GetFreeeTags200ResponseInner
 */
export interface GetFreeeTags200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetFreeeTags200ResponseInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetFreeeTags200ResponseInner
     */
    'type': GetFreeeTags200ResponseInnerTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetFreeeTags200ResponseInner
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetFreeeTags200ResponseInner
     */
    'shortcut1': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetFreeeTags200ResponseInner
     */
    'shortcut2': string | null;
}

export const GetFreeeTags200ResponseInnerTypeEnum = {
    section: 'SECTION',
    item: 'ITEM',
    segmentTag1: 'SEGMENT_TAG1',
    segmentTag2: 'SEGMENT_TAG2',
    segmentTag3: 'SEGMENT_TAG3',
    memoTag: 'MEMO_TAG'
} as const;

export type GetFreeeTags200ResponseInnerTypeEnum = typeof GetFreeeTags200ResponseInnerTypeEnum[keyof typeof GetFreeeTags200ResponseInnerTypeEnum];


